module.exports = __webpack_public_path__ + "img/fc_ultraplatinum.81a78dd1.png";